import React, { useContext } from 'react'
import { ThemeContext } from '../context/ThemeContext.jsx'

export default function BackgroundScene() {
  const { theme } = useContext(ThemeContext)
  if (!theme.backgroundImage) return null

  return (
    <>
      <img
        src={theme.backgroundImage}
        alt=""
        style={{
          position: 'fixed',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -2,
          pointerEvents: 'none',
        }}
      />
      {theme.overlayColor && (
        <div style={{
          position: 'fixed',
          inset: 0,
          background: theme.overlayColor,
          zIndex: -1,
          pointerEvents: 'none',
        }} />
      )}
    </>
  )
}
